import styled from "@emotion/styled";
import {mq} from "@styles/helpers";
import {Devices} from "@styles/tokens";

export const StudentAdminGrid = styled.div<{frontPage?:boolean}>`
  width:100%;
  display:grid;
  grid-template-columns: ${props => props.frontPage?"1fr 3fr":"1fr 2fr"};
  gap:40px;

  ${mq(Devices.mobile)} {
    grid-template-columns: 1fr;
    gap:20px;
    padding:0 10px 20px 10px;
  }
`;

export const StudentAdminContainer = styled.div<{gapOff?:boolean, span?:Number}>`
    position: relative;
    width:100%;
    height:83vh;
    overflow-y: auto;
    display:flex;
    flex-direction: column;
    gap: ${props => props.gapOff?"unset":"10px"};
    ${props => props.span?"grid-column: span " + props.span + ";":""};
  
    h1 {
      font-size: 24px;
    }

    ${mq(Devices.mobile)} {
      height:auto;
      grid-column: unset;
      ${props => props.span?"grid-row-start: 0":"unset"};
      ${props => props.span?"grid-row-end: 1":"unset"};
    }
`;

export const NoCourses = styled.div`
    width: 100%;
  display: flex;
  justify-content: center;
  span {
    margin-top: 20px;
    font-weight: 500;
    font-size: 28px;
    color: #5e5e5e;
  }
`

export const MissingContent = styled.div`
    display:flex;
    align-items: flex-end;
    justify-content: center;
    height:40vh;
    width:100%;
    grid-column: 1 / 5;
    min-height: max-content;
    span{
        font-weight: 500;
        font-size: 32px;
        color: #5e5e5e;
    }
`;